import React from 'react';
import clsx from 'clsx';

const Card = ({ 
  children, 
  className,
  variant = 'default',
  padding = 'md',
  shadow = 'sm',
  ...props 
}) => {
  const baseClasses = 'bg-white border border-gray-200 rounded-lg';
  
  const variants = {
    default: '',
    elevated: 'border-0',
    outlined: 'border-2',
    ghost: 'bg-transparent border-transparent'
  };

  const paddings = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
    xl: 'p-8'
  };

  const shadows = {
    none: '',
    xs: 'shadow-xs',
    sm: 'shadow-sm',
    base: 'shadow',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl'
  };

  const classes = clsx(
    baseClasses,
    variants[variant],
    paddings[padding],
    shadows[shadow],
    className
  );

  return (
    <div className={classes} {...props} data-otg-component={props['data-otg-component'] || 'Card'}>
      {children}
    </div>
  );
};

const CardHeader = ({ children, className, ...props }) => {
  return (
    <div className={clsx('pb-3 border-b border-gray-200', className)} {...props} data-otg-component={props['data-otg-component'] || 'CardHeader'}>
      {children}
    </div>
  );
};

const CardAction = ({ children, className, ...props }) => {
  return (
    <div className={clsx('shrink-0', className)} {...props} data-otg-component={props['data-otg-component'] || 'CardAction'}>
      {children}
    </div>
  );
};

const CardBody = ({ children, className, ...props }) => {
  return (
    <div className={clsx('py-3', className)} {...props} data-otg-component={props['data-otg-component'] || 'CardContent'}>
      {children}
    </div>
  );
};

const CardFooter = ({ children, className, ...props }) => {
  return (
    <div className={clsx('pt-3 border-t border-gray-200', className)} {...props} data-otg-component={props['data-otg-component'] || 'CardFooter'}>
      {children}
    </div>
  );
};

const CardTitle = ({ children, className, ...props }) => {
  return (
    <h3 className={clsx('text-lg font-semibold text-gray-900', className)} {...props} data-otg-component={props['data-otg-component'] || 'CardTitle'}>
      {children}
    </h3>
  );
};

const CardDescription = ({ children, className, ...props }) => {
  return (
    <p className={clsx('text-sm text-gray-600 mt-1', className)} {...props} data-otg-component={props['data-otg-component'] || 'CardDescription'}>
      {children}
    </p>
  );
};

Card.Header = CardHeader;
Card.Action = CardAction;
Card.Body = CardBody;
Card.Content = CardBody;
Card.Footer = CardFooter;
Card.Title = CardTitle;
Card.Description = CardDescription;

export default Card;
